<style lang="less">
.Guide{
	.head{
		height: 182px;
		display: -webkit-box; display:flex;
		flex-direction: column;
		-webkit-box-align: center; align-items: center;
		-webkit-box-pack: center; justify-content: center;
		.tit{
			color: #000000;
			font-size: 18px;
			font-weight: 500;
			padding-bottom: 8px;
		}
		.subtit{
			color: #999;
			font-size: 12px;
			font-weight: 400;
		}
		h1{
			font-size: 42px;
			color: #d33a2a;
			padding: 16px 0 0 0;
		}
		.desc{
			color: #999;
			font-size: 14px;
		}
	}
	.cp{
		display: -webkit-box; display:flex;
		-webkit-box-align: center; align-items: center;
		-webkit-box-pack: center; justify-content: center;
		background: #fff;
		line-height: 18px;
		strong{
			line-height: 18px;
			color: #d33a2a;
			padding: 0 4px;
		}
	}
}
</style>

<template>
	<!-- Main Guide -->
	<section class="Guide">
		<div class="head">
			<div class="tit">自动赚钱的钱包账户</div>
			<p class="subtit">1 万元日收益 {{product.exp_per_profit}} 元</p>
			<h1>{{product.rate}}%</h1>
			<p class="desc">近七日年化收益率</p>
		</div>
		<div class="feature">
			<point></point>
		</div>

		<div class="cp">余额+由<strong @click="richText"> 国寿安保鑫钱包货币 </strong>提供</div>
		<div class="space"></div>
		<footbtn btn-txt="立即开通" :is-on="true" v-on:next="next"></footbtn>

	</section>
</template>

<script>
	import footbtn from '@flyme/jr/flyme7/component/foot-btn-simple/foot-btn-simple.vue';
	import android from '@flyme/jr/js/android.js';

	import point from '../components/point.vue';
	import axios from '../axios.js';
	import apis from '../apis.js';
	import config from '../config.js';

	export default {
		data: function () {
			return {
				cache: true,
				product: {
					history: {}
				},
				status: 0
			};
		},
		components: {
			point,
			footbtn
		},
		mounted: function () {
			const query = this.$route.query; // acct_status
			if(query && query.acct_query) {
				try {
					const info = JSON.parse(query.acct_query);
					this.status = info.acct_status || 0;
				} catch(e) {
					console.log(e)
				}
			}
			android('setTitle', {
				title:"余额+"
			});
			android('startLoading', {mes: '正在加载'});
			this.getProduct();
		},
		methods: {
			getProduct: function () {
				let _this = this;
				axios.post(apis.acctplus_product_query, {
					show_type: 1
				}).then(function(d) {
					console.log('acctplus_product_query', d, d.value.history_rates);
					android('stopLoading');
					if (d.value) {
						d.value.history = {};
						_this.product = d.value;
					}
				});
			},
			next: function () {
				// let _this = this;
				// android('startPageWithCallback', {
				// 	url: config.staticURL + '/#/identity',
				// 	start_type:1,
				// 	data:'',
				// 	display:{
				// 		title:'转入'
				// 	}
				// }, function () {
				// 	_this.getDetail();
				// });
				if (this.status === 0) {
					android('showDialog', {
						title: '',
						message: '系统维护中......',
						okCallBack: 'G_dialogOk'
					});
					return;
				}
				this.$router.replace({ path: 'identity' });
			},
			richText: function () {
				android('startPage', {
					url: config.staticURL + '/#/acctplus/detail',
					start_type:1,
					data:'',
					display:{
						title: '国寿安保鑫钱包货币'
					}
				});
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Guide.vue